import { render } from "./RadioButtonField.vue?vue&type=template&id=09013db5&ts=true"
import script from "./RadioButtonField.vue?vue&type=script&lang=ts"
export * from "./RadioButtonField.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__